export const LOCAL_STORAGE_USER_TOKEN_KEY = "dar_share_user_token";
export const LOCAL_STORAGE_USER_DATA_KEY = "dar_share_user_data";
export const APP_NAME = "دار شير";
